import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = {
  key: 0,
  class: "h-5 w-5 animate-spin rounded-full border-2 border-white border-t-transparent"
}
const _hoisted_3 = { key: 1 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("button", {
    class: "flex w-full items-center justify-center gap-2 bg-blue-600 px-5 font-bold text-white transition h-[52px] rounded-[10px] text-[15.5px] shadow-[0_1px_2px_rgba(0,0,0,0.12),0_8px_20px_rgba(37,99,235,0.22)] hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-600/20 disabled:cursor-wait disabled:opacity-80",
    type: "submit",
    disabled: $props.loading
  }, [
    ($props.loading)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2))
      : _createCommentVNode("v-if", true),
    ($props.loading)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString($props.loadingLabel), 1 /* TEXT */))
      : _renderSlot(_ctx.$slots, "default", { key: 2 })
  ], 8 /* PROPS */, _hoisted_1))
}